export * from './enums'

export const PathDef = {
  // 首页
  Index: {
    path: '/index.html',
    shortLinkFlag: true,
    requiredQueryField: [],
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  // 商品详情页
  GoodsDetail: {
    shortLinkFlag: true,
    requiredQueryField: ['id'],
    path: '/goodsDetail.html',
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  GoodsDetailOld: {
    requiredQueryField: ['id'],
    path: '/goodsDetailOld.html',
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  // 拼团分享页- 客态
  GroupDetail: {
    shortLinkFlag: true,
    requiredQueryField: ['id', 'groupId'],
    path: '/groupDetail.html',
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  // 拼团详情页- 主态
  GroupGoodsDetail: {
    shortLinkFlag: true,
    requiredQueryField: ['id'],
    path: '/groupGoodsDetail.html',
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  // 从拼团分享页面主态进入的一个 页面
  GroupShare: {
    path: '/groupShare.html',
    requiredQueryField: ['id', 'groupId'],
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  // 秒杀详情页
  SpikeDetail: {
    shortLinkFlag: true,
    requiredQueryField: ['id'],
    path: '/spikeDetail.html',
    allowQueryField: ['channelId', 'source_disable_dchn'],
  },
  // 订单详情页
  OrderDetail: {
    shortLinkFlag: true,
    // requiredQueryField: ['id'], // 买赠商品分享出去的订单详情页不需要校验id参数，报警太多暂时下掉
    path: '/orderDetail.html',
    allowQueryField: [],
  },
  // 快生专权益套餐详情页
  RightGoodsDetail: {
    shortLinkFlag: true,
    requiredQueryField: ['id'],
    path: '/rightGoodsDetail.html',
  },
}

export const CheckFieldsDef = {
  // 小程序下需要带的字段
  miniRequiredFields: ['openid', 'token', 'cityid'],
  queryFields: ['from', 'xenv'],
}
